import { IonContent, IonicSlides } from '@ionic/react';
import '@ionic/react/css/ionic-swiper.css';
import { ReactElement, useRef } from 'react';
import { Swiper as SwiperInterface } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import {
  Autoplay,
  Keyboard,
  Pagination,
  Scrollbar,
  Zoom,
} from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import './login.css';
import * as content from './welcome-content';

const LoginWelcome = (): ReactElement => {
  const swiperRef = useRef<SwiperInterface>();

  return (
    <IonContent className="login-welcome-content ion-hide-sm-down">
      <Swiper
        className="login-content"
        key={Object.keys(content).join('_')}
        onSwiper={(ref) => (swiperRef.current = ref)}
        modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
        pagination={false}
        initialSlide={0}
        speed={400}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
      >
        {Object.keys(content).map((key) => {
          const typedContent = content as Record<string, () => ReactElement>;
          const SlideContent = typedContent[key];
          return (
            <SwiperSlide className="slide" key={key}>
              <SlideContent />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </IonContent>
  );
};

export { LoginWelcome };
